import { render } from "./dashboardCard.vue?vue&type=template&id=0f5fd373"
import script from "./dashboardCard.vue?vue&type=script&lang=js"
export * from "./dashboardCard.vue?vue&type=script&lang=js"

import "./dashboardCard.vue?vue&type=style&index=0&id=0f5fd373&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__